import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class GroupsGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Group',
            ROUTE_PATH.groups,
            ROUTE_PATH.groupsAdd,
            false,
            true,
            8,
            false,
            true,
            ['group_name'],
            false,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            null,
            null,
            null,
            true,
            null,
            { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            true,
            { isExtraActions: false, btnLabel: '' },
            // {isCheckboxEmit: false, emitKey: 'group_id', checkedKey: '', valueKey: ''},
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const group_name = new Headers('Group Name', 'group_name', false, true, 'text','0', {
            isColumnNavigation: true,
            navigationUrl: ROUTE_PATH.groupsAdd,
            navigateOperationType: OperationType.UPDATE,
            navigateTransferData: new WidgetModel()
        });
        const batch = new Headers('Batch', 'batch_number', false, true, 'text');
        const added_students = new Headers('Added Students', 'studentcount', false, true, 'text', '0', {
            isColumnNavigation: true,
            navigationUrl: ROUTE_PATH.groupsAdd,
            navigateOperationType: OperationType.UPDATE,
            navigateTransferData: new WidgetModel()
        });

        headers.push(group_name);
        headers.push(batch);
        headers.push(added_students);
        return headers;
    }
}